/*jslint browser: true, devel: true */
"use strict";

// Passwordless submission and checkout identity flow.

function getCurrencySymbol() {
  return document.cookie.includes('currency=EUR') ? '€' : '$';
}

// --------
// Dropzone
// --------

var debug = false;
var thisDropzone;
var maxImageWidth = 10000;
var maxImageHeight = 10000;
var submissionForm = document.getElementById("submission");
var selectButton = document.getElementById("select");
var guestSubmissionEnabled = submissionForm && submissionForm.dataset.guestEnabled === "true";
var variablePricing = false;

var progressBarContainer = document.querySelector('.dz-progress-bar-total');
var progressBarText = document.querySelector('.dz-progress-bar-text');
var progressBarTotal = document.querySelector('.dz-progress-bar-total .dz-upload');
var termsconditions = document.querySelector('.terms-conditions');
var progresstext = document.querySelector('.progress-text');
var messageHideTimeout = null;

// Submission is coordinated by Dropzone/XHR below. Never allow the browser's
// native form submission (for example, when Enter is pressed in a field),
// because that would navigate directly to admin-post.php and display JSON.
submissionForm.addEventListener("submit", function(event) {
    event.preventDefault();
});

function scrollToLoginGate() {
    var loginCard = document.getElementById("submit-login-card");

    if (!loginCard) {
        return;
    }

    loginCard.scrollIntoView({
        behavior: "smooth",
        block: "center"
    });

    loginCard.classList.remove("submit-login-highlight");
    window.setTimeout(function() {
        loginCard.classList.add("submit-login-highlight");
    }, 50);
    window.setTimeout(function() {
        loginCard.classList.remove("submit-login-highlight");
    }, 2200);
}

function scrollToPricingOptions() {
    var pricingOptions = document.getElementById("submit-pricing-options");

    if (!pricingOptions) {
        return;
    }

    pricingOptions.scrollIntoView({
        behavior: "smooth",
        block: "center"
    });

    pricingOptions.classList.remove("submit-pricing-highlight");
    window.setTimeout(function() {
        pricingOptions.classList.add("submit-pricing-highlight");
    }, 50);
    window.setTimeout(function() {
        pricingOptions.classList.remove("submit-pricing-highlight");
    }, 2200);
}

function scrollToContactInfo() {
    var contactInfo = document.getElementById("submit-contact-info");

    if (!contactInfo) {
        return;
    }

    contactInfo.scrollIntoView({
        behavior: "smooth",
        block: "start"
    });
}

function rotateImageFile(file, degrees, done) {
    var reader = new FileReader();

    reader.onerror = function() { done(file); };
    reader.onload = function(event) {
        var image = new Image();
        image.onerror = function() { done(file); };
        image.onload = function() {
            var quarterTurn = Math.abs(degrees % 180) === 90;
            var canvas = document.createElement("canvas");
            canvas.width = quarterTurn ? image.naturalHeight : image.naturalWidth;
            canvas.height = quarterTurn ? image.naturalWidth : image.naturalHeight;

            var context = canvas.getContext("2d");
            context.translate(canvas.width / 2, canvas.height / 2);
            context.rotate(degrees * Math.PI / 180);
            context.drawImage(image, -image.naturalWidth / 2, -image.naturalHeight / 2);

            canvas.toBlob(function(blob) {
                done(blob || file);
            }, file.type === "image/png" ? "image/png" : "image/jpeg", 0.95);
        };
        image.src = event.target.result;
    };
    reader.readAsDataURL(file);
}

// Define the prices array to match the one in your submission.php file
var prices = {
    1: 15.00,
    2: 15.00,
    3: 30.00,
    4: 30.00,
    5: 30.00,
    6: 45.00,
    7: 45.00,
    8: 45.00,
    9: 45.00,
    10: 45.00,
    11: 45.00,
    12: 45.00
};
var totalCost;
var submissionAttemptId = "submit-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 8);

function createUploadAttemptId() {
    return "upload-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 10);
}

// Telemetry is optional and must never block submission or upload handling.
function trackSubmissionEvent(event, details) {
    try { if (window.tipSubmitAnalytics) window.tipSubmitAnalytics.track(event, details); } catch (e) {}
}

function reportSubmissionError(stage, code, details) {
    try {
        if (window.tipSubmitAnalytics) window.tipSubmitAnalytics.track('submission_error', Object.assign({}, details || {}, {
            request_id: (details && details.request_id) || window.tipSubmitAnalytics.requestId(),
            stage: stage,
            error_code: code
        }));
    } catch (e) {}
}

function appendSubmissionAnalytics(formData, requestId) {
    try { if (window.tipSubmitAnalytics) window.tipSubmitAnalytics.append(formData, requestId); } catch (e) {}
}

function extractUploadErrorDetails(errorMessage, xhr, file) {
    var browserMessage = "";
    var serverMessage = "";
    var hint = file && file._tipFailureHint ? file._tipFailureHint : "";
    var status = xhr ? xhr.status : 0;

    if (typeof errorMessage === "string") {
        browserMessage = errorMessage;
        serverMessage = errorMessage;
    } else if (errorMessage && typeof errorMessage === "object") {
        browserMessage = errorMessage.message || "";
        serverMessage = errorMessage.message || "";

        if (errorMessage.data && errorMessage.data.details && errorMessage.data.details.reason) {
            hint = errorMessage.data.details.reason;
        }
    }

    if (xhr && xhr.responseText) {
        try {
            var response = JSON.parse(xhr.responseText);
            if (response && typeof response === "object") {
                if (response.message) {
                    serverMessage = response.message;
                }
                if (response.data && response.data.details && response.data.details.reason) {
                    hint = response.data.details.reason;
                }
            }
        } catch (e) {
            if (!serverMessage && xhr.responseText.length < 240) {
                serverMessage = xhr.responseText;
            }
        }
    }

    if (!hint && browserMessage) {
        if (/timedout/i.test(browserMessage)) {
            hint = "timeout";
        } else if (/network/i.test(browserMessage)) {
            hint = "network_error";
        }
    }

    return {
        status: status,
        browserMessage: browserMessage,
        serverMessage: serverMessage,
        hint: hint
    };
}

function getFriendlyUploadErrorMessage(details) {
    if (details.status === 0) {
        if (details.hint === "timeout" || /timedout/i.test(details.browserMessage || "")) {
            return "Upload timed out before the server finished responding. Please try again, ideally on a stable connection.";
        }

        if (details.hint === "abort") {
            return "Upload was interrupted before it completed. Please try again.";
        }

        return "Upload was interrupted before the server returned a response. Please try again.";
    }

    if (details.status >= 500) {
        return "The server had trouble processing this image. Please try again in a moment.";
    }

    if (details.serverMessage) {
        return details.serverMessage;
    }

    if (details.browserMessage) {
        return details.browserMessage;
    }

    return "An error occurred while uploading. Please try again.";
}

function logClientUploadError(payload) {
    fetch("/wp-json/tip/v1/upload-error", {
        method: "POST",
        keepalive: true,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
    }).catch(function() {
        if (debug) console.log("Upload error logging request failed.");
    });
}

Dropzone.options.submission = {
    url: "/wp-json/tip/v1/upload",
    maxFilesize: 12,
    maxFiles: 6,
    acceptedFiles: "image/jpg,image/jpeg,image/png",
    autoProcessQueue: false,
    parallelUploads: 1,
    uploadMultiple: false,
    timeout: (10 * 60 * 1000),
    addRemoveLinks: true,
    clickable: ".js-add-image-trigger",
    thumbnailWidth: null,
    thumbnailHeight: null,
    previewTemplate: document.getElementById("preview-template").innerHTML,
    previewsContainer: document.getElementById("preview-container"),
    dictDefaultMessage: "",
    retryChunks: false,
    dictRemoveFile: "Remove",
    dictCancelUpload: "Cancel",
    dictFileTooBig: "Image is too big ({{filesize}}MB), please upload JPEG or PNG Max. 10MB",

    transformFile: function(file, done) {
        var rotation = file._tipRotation || 0;
        if (!rotation) {
            done(file);
            return;
        }
        rotateImageFile(file, rotation, done);
    },

    init: function() {
        if (debug) console.log("Dropzone loaded.");

        thisDropzone = this;

        let totalFiles = 0;
        let completedFiles = 0;
        let uploadAborted = false;
        let submitStarted = false;
        let submissionPending = false;


        // var buttonClear = document.getElementById("clear");
        var buttonAdd = document.getElementById("add-image");
        var addButtons = document.getElementById("add-buttons");
        var countInfo = document.getElementById("counter-info");
        var elemMessage = document.getElementById("uploader-message");
        var hiddenInput = document.querySelectorAll(".dz-hidden-input")[0];
        var removeImage = document.querySelectorAll(".dz-remove")[0];
        var allAdded = document.querySelectorAll(".dz-clickable")[1];
        var countLeft  = thisDropzone.options.maxFiles - thisDropzone.files.length;
        var totalPrice = document.getElementById("totalprice");
        var initiallySelectedPrice = document.querySelector('input[name="price"]:checked');
        thisDropzone.options.maxFiles = initiallySelectedPrice
            ? parseInt(initiallySelectedPrice.value, 10)
            : 6;

        function updatePreviewNumbers() {
            var activeFiles = thisDropzone.files.filter(function (item) {
                return item.previewElement && !item.previewElement.classList.contains("dz-error");
            });

            activeFiles.forEach(function (item, index) {
                var badge = item.previewElement.querySelector(".dz-image-number");
                if (!badge) {
                    return;
                }

                badge.textContent = index + 1;
                item.previewElement.classList.toggle("has-image-number", activeFiles.length > 1);
            });
        }

        function updateUploadFooterState() {
            var addImageButton = document.querySelector(".btn-add-image");
            var maxFiles = parseInt(thisDropzone.options.maxFiles, 10) || 0;
            var imageCount = thisDropzone.files.length;
            var imagesNeeded = Math.max(maxFiles - imageCount, 0);

            if (!addImageButton || !countInfo || !maxFiles) {
                return;
            }

            if (imageCount > maxFiles) {
                var imagesToRemove = imageCount - maxFiles;
                countInfo.hidden = false;
                countInfo.value = "✕ Remove " + imagesToRemove + " " + (imagesToRemove === 1 ? "image" : "images");
                countInfo.classList.add("is-over-limit");
                addImageButton.classList.add("hidden");
                addImageButton.setAttribute("disabled", "disabled");
                return;
            }

            countInfo.classList.remove("is-over-limit");

            if (imageCount === maxFiles) {
                countInfo.hidden = false;
                countInfo.value = "✓ Images: " + imageCount + " / " + maxFiles;
                addImageButton.classList.add("hidden");
                addImageButton.setAttribute("disabled", "disabled");
                return;
            }

            countInfo.hidden = true;
            countInfo.value = "";
            addImageButton.removeAttribute("disabled");
            addImageButton.classList.remove("hidden");
            addImageButton.value = "Add " + imagesNeeded + " " + (imagesNeeded === 1 ? "image" : "images");
        }

        window.tipUpdateUploadFooterState = updateUploadFooterState;

        // Inside the init function of Dropzone options

        // Disable Dropzone functionality initially
        thisDropzone.hiddenFileInput.setAttribute("disabled", "disabled");

        // Update event listener for dropzone clickable area
        var clickableAreas = document.querySelectorAll(".js-add-image-trigger");
        var previewContainer = document.getElementById("preview-container");

        clickableAreas.forEach(function(clickableArea) {
            clickableArea.addEventListener("click", function(event) {
                if (!guestSubmissionEnabled && !document.body.classList.contains("logged-in")) {
                    event.preventDefault();
                    event.stopPropagation();
                    displayMessage({ status: "error", message: "Please log in to upload photos." });
                    scrollToLoginGate();
                    return;
                }

                var selectedPrice = document.querySelector('input[name="price"]:checked');
                if (!selectedPrice) {
                    event.preventDefault();
                    event.stopPropagation();
                    displayMessage({ status: "error", message: "Please select a pricing option first." });
                    scrollToPricingOptions();
                    return;
                }

                thisDropzone.hiddenFileInput.removeAttribute("disabled");
            }, true);
        });

        ["dragenter", "dragover", "drop"].forEach(function(eventName) {
            previewContainer.addEventListener(eventName, function(event) {
                if (!guestSubmissionEnabled && !document.body.classList.contains("logged-in")) {
                    return;
                }

                if (document.querySelector('input[name="price"]:checked')) {
                    return;
                }

                event.preventDefault();
                event.stopPropagation();
                displayMessage({ status: "error", message: "Please select a pricing option first." });
                scrollToPricingOptions();
            });
        });

        document.querySelectorAll(".js-login-gate").forEach(function(gatedArea) {
            gatedArea.addEventListener("click", function(event) {
                if (guestSubmissionEnabled || document.body.classList.contains("logged-in")) {
                    return;
                }

                event.preventDefault();
                displayMessage({
                    status: "error",
                    message: gatedArea.dataset.gateMessage || "Please login or register first."
                });
                scrollToLoginGate();
            });

            ["dragenter", "dragover", "drop"].forEach(function(eventName) {
                gatedArea.addEventListener(eventName, function(event) {
                    if (guestSubmissionEnabled || document.body.classList.contains("logged-in")) {
                        return;
                    }

                    event.preventDefault();
                    displayMessage({
                        status: "error",
                        message: gatedArea.dataset.gateMessage || "Please login or register first."
                    });
                    scrollToLoginGate();
                });
            });
        });

        // ----------
        // Submission
        // ----------

        selectButton.addEventListener("click", function(event){
            event.preventDefault();
            if (submitStarted || submissionPending) return;
            if (guestSubmissionEnabled && typeof submissionForm.reportValidity === "function" && !submissionForm.reportValidity()) {
                scrollToContactInfo();
                return;
            }
            uploadAborted = false;
            if ([1,3,6].includes(thisDropzone.files.length)) {
                if (thisDropzone.getAcceptedFiles().length !== thisDropzone.files.length) {
                    displayMessage({ status: "error", message: "Please remove or replace invalid images before submitting." });
                    return;
                }
                // Preserve successful uploads and retry only failed/interrupted files.
                uploadedFiles = [];
                thisDropzone.files.forEach(function(file) {
                    if (file.status === Dropzone.SUCCESS && file._tipUploadedFiles) {
                        uploadedFiles = uploadedFiles.concat(file._tipUploadedFiles);
                    } else if (file.accepted && file.status !== Dropzone.QUEUED) {
                        file.status = Dropzone.ADDED;
                        if (file.previewElement) {
                            file.previewElement.classList.remove("dz-error", "dz-success", "dz-complete");
                        }
                        thisDropzone.enqueueFile(file);
                    }
                });
                submitStarted = true; // ✅ ARM QUEUE

                totalFiles = thisDropzone.getAcceptedFiles().length;
                completedFiles = thisDropzone.files.filter(function(file) {
                    return file.status === Dropzone.SUCCESS && file._tipUploadedFiles;
                }).length;

                progressBarTotal.style.width = (completedFiles / totalFiles * 100) + "%";
                progressBarContainer.classList.remove("hidden");
                progresstext.classList.remove("hidden");
                progressBarContainer.classList.add("processing");
                termsconditions.classList.add("hidden");
                progressBarText.textContent = `Uploading ${Math.min(completedFiles + 1, totalFiles)} of ${totalFiles}`;
                selectButton.disabled = true;

                if (completedFiles === totalFiles) {
                    thisDropzone.emit("queuecomplete");
                } else {
                    thisDropzone.processQueue();
                }

            } else {
                event.preventDefault();
                selectButton.setAttribute("disabled", "disabled");
                displayMessage({
                    status: "error",
                    message: "You can upload 1, 3 or 6 images only."
                });
            }
        });


        this.on("complete", function () {

            // ❌ Never chain uploads unless submit was clicked
            if (!submitStarted) {
                return;
            }

            if (
                this.getQueuedFiles().length > 0 &&
                this.getUploadingFiles().length === 0
            ) {
                this.processQueue();
            }
        });



        this.on("error", function(file, errorMessage, xhr) {
            if (thisDropzone._redirecting) return;
            submitStarted = false;

            var message;
            var details = extractUploadErrorDetails(errorMessage, xhr, file);

            if (!xhr) {
                uploadAborted = true;
                message = details.browserMessage || "Upload error. Please try again.";
            } else {
                message = getFriendlyUploadErrorMessage(details);
            }

            if (xhr && (xhr.status === 0 || xhr.status >= 400)) {
                trackSubmissionEvent('upload_error', {
                    request_id: file._tipAnalyticsRequest || '', status: xhr.status,
                    error_code: details.hint || (xhr.status === 0 ? 'no_response' : 'http_' + xhr.status),
                    duration_ms: file._tipStartedAt ? Date.now() - file._tipStartedAt : 0,
                    file_size: file.size || 0
                });
                logClientUploadError({
                    upload_attempt_id: file._tipUploadId || "",
                    submission_attempt_id: submissionAttemptId,
                    browser_message: details.browserMessage,
                    server_message: details.serverMessage,
                    hint: details.hint,
                    status: xhr.status,
                    elapsed_ms: file._tipStartedAt ? Date.now() - file._tipStartedAt : 0,
                    progress: file._tipLastProgress || 0,
                    file: { name: file.name, size: file.size, type: file.type },
                    ua: navigator.userAgent
                });
            }

            displayMessage({ status: "error", message: message });
            if (file.previewElement) {
                var errorLabel = file.previewElement.querySelector("[data-dz-errormessage]");
                if (errorLabel) errorLabel.textContent = message;
            }
            selectButton.classList.remove("is-loading");
            selectButton.disabled = false;
        });

        this.on("maxfilesexceeded", function(file) {
            uploadAborted = true;
            submitStarted = false;

            // Remove the extra file immediately
            this.removeFile(file);

            displayMessage({
                status: "error",
                message: "You can upload 1, 3 or 6 images only."
            });
        });


        // ------------------
        // File added handler
        // ------------------

        thisDropzone.on("addedfile", function(file) {
            console.log("File added.");
            updatePreviewNumbers();

            var rotateButton = file.previewElement && file.previewElement.querySelector(".dz-rotate");
            var thumbnail = file.previewElement && file.previewElement.querySelector("[data-dz-thumbnail]");
            if (rotateButton && thumbnail) {
                rotateButton.addEventListener("click", function(event) {
                    event.preventDefault();
                    event.stopPropagation();
                    file._tipRotation = ((file._tipRotation || 0) + 90) % 360;
                    thumbnail.style.transform = "rotate(" + file._tipRotation + "deg)";
                    rotateButton.setAttribute("aria-label", "Rotate image clockwise. Current rotation: " + file._tipRotation + " degrees");
                });
            }

            if (!document.querySelector('input[name="price"]:checked')) {
                thisDropzone.removeFile(file);
                displayMessage({
                    status: "error",
                    message: "Please select a pricing option first."
                });
                scrollToPricingOptions();
                return;
            }

            // Update total cost display
            updateTotalCost();

            // elemMessage.innerHTML = "&nbsp;";

            // remove file if found to be duplicate
            // SO: http://stackoverflow.com/a/32841273/401980
            if (thisDropzone.files.length) {
                var _i, _len;

                for (
                    _i = 0, _len = thisDropzone.files.length;
                    _i < _len - 1;
                    _i++
                ) {
                    // -1 to exclude current file

                    if (
                        thisDropzone.files[_i].name === file.name &&
                        thisDropzone.files[_i].size === file.size &&
                        thisDropzone.files[_i].lastModifiedDate.toString() ===
                            file.lastModifiedDate.toString()
                    ) {
                        if (debug) console.log("Duplicate detected, removing.");
                        thisDropzone.removeFile(file);

                        displayMessage({
                            status: "error",
                            message: "Image already added."
                        });
                    }
                }
            }

            var countLeft = thisDropzone.options.maxFiles - thisDropzone.files.length;
            var toomuch = thisDropzone.files.length - thisDropzone.options.maxFiles;

            if (variablePricing === false) {
            if (thisDropzone.files.length > thisDropzone.options.maxFiles) {
                if (debug) console.log("Exceeds max file limit, removing.");
                thisDropzone.removeFile(file);

            } else if (thisDropzone.files.length === thisDropzone.options.maxFiles) {
                console.log("File limit reached, enabling submission.");
                addButtons.removeAttribute("hidden");
                selectButton.removeAttribute("disabled");
                document.querySelector(".btn-add-image").classList.add("hidden");
                buttonAdd.hidden = true;
                countInfo.value = "✔ Images: " + thisDropzone.files.length + " / " + thisDropzone.options.maxFiles;

            } else if (thisDropzone.files.length < thisDropzone.options.maxFiles) {
                console.log("File added, still below limit.");
                buttonAdd.hidden = true;
                selectButton.setAttribute("disabled", "disabled");
                document.querySelector(".btn-add-image").classList.remove("hidden");
                countLeft = thisDropzone.options.maxFiles - thisDropzone.files.length;

                if (countLeft == 1) {
                    countInfo.value = "Please add " + countLeft + " image.";
                }
                if (countLeft != 1) {
                    countInfo.value = "Please add " + countLeft + " images.";
                }
            }
            }
            else if (variablePricing) {

                if ( thisDropzone.files.length >= 6 && thisDropzone.files.length != 12) {
                updateTotalCost();
                countInfo.value = "✔ Images: " + thisDropzone.files.length;
                document.querySelector('.dz-message').style.display = "none";
                document.querySelector(".btn-add-image").removeAttribute("disabled");
                document.querySelector(".btn-add-image").classList.remove("hidden");
                // totalPrice.removeAttribute("hidden");
                selectButton.removeAttribute("disabled");
                console.log("Number of images reached.");
                }

                else if ( thisDropzone.files.length === 12) {
                updateTotalCost();
                countInfo.value = "✔ Images: " + thisDropzone.files.length;
                selectButton.removeAttribute("disabled");
                console.log("Number of images reached.");
                addButtons.removeAttribute("hidden");
                document.querySelector(".btn-add-image").setAttribute("disabled","disabled");
                document.querySelector(".btn-add-image").classList.add("hidden");
                document.querySelector('.dz-message').style.display = "none";
                countInfo.value = "✔ Images: " + thisDropzone.files.length;
                // totalPrice.removeAttribute("hidden");
                }
            };

            // If not logged in
            if (!guestSubmissionEnabled && !document.body.classList.contains( 'logged-in' )) {
                thisDropzone.removeFile(file);
                console.log("Not logged in.");
                displayMessage({
                        status: "error",
                        message: "Please login or register first."
                        });
                scrollToLoginGate();
                return;
            }


            // If we have ANY files, enable the count
            if (thisDropzone.files.length >= 1 ) {
                if (debug) console.log("We have files, enable clear, hide message.");

                addButtons.removeAttribute("hidden");
                document.querySelector('.dz-message').style.display = "none";
            } else if (thisDropzone.files.length <= 0 ) {
                console.log("All images removed");
                addButtons.removeAttribute("hidden");
            }

            updateUploadFooterState();
        });

        this.on("thumbnail", function(file) {
            if (file.width > maxImageWidth || file.height > maxImageHeight) {
                thisDropzone.removeFile(file);
                displayMessage({
                    status: "error",
                    message: "This image's resolution exceeds the maximum of 10000 pixels."
                });
            }
        });

        this.on("removedfile", function(file) {
            console.log("File removed, disabling submit.");
            updatePreviewNumbers();
            // Update total cost display
            updateTotalCost();
            countLeft = thisDropzone.options.maxFiles - thisDropzone.files.length;

            if (variablePricing && thisDropzone.files.length < 6) {
                thisDropzone.options.maxFiles = 6;
                countLeft = thisDropzone.options.maxFiles - thisDropzone.files.length;
                updateTotalCost();
                if (countLeft == 1) {
                    countInfo.value = "Please add " + countLeft + " image minimum.";
                }
                if (countLeft != 1) {
                    countInfo.value = "Please add " + countLeft + " images minimum.";
                }
                selectButton.setAttribute("disabled","disabled");
                // totalPrice.setAttribute("hidden","hidden");
                document.querySelector(".btn-add-image").classList.remove("hidden");
                document.querySelector(".btn-add-image").removeAttribute("disabled");

            }

            if (variablePricing && thisDropzone.files.length >= 6) { 
                selectButton.removeAttribute("disabled");
                console.log("Number of images reached.");
                addButtons.removeAttribute("hidden");
                allAdded.setAttribute("disabled", "");
                document.querySelector('.dz-message').style.display = "none";
                document.querySelector(".btn-add-image").classList.remove("hidden");
                document.querySelector(".btn-add-image").removeAttribute("disabled");
                countInfo.value = "✔ Images: " + thisDropzone.files.length;
            }

            if (variablePricing && thisDropzone.files.length >= 13) { 
                selectButton.removeAttribute("disabled");
                console.log("Number of images reached.");
                addButtons.removeAttribute("hidden");
                allAdded.setAttribute("disabled", "");
                document.querySelector('.dz-message').style.display = "none";
                document.querySelector(".btn-add-image").classList.add("hidden");
                document.querySelector(".btn-add-image").setAttribute("disabled","disabled");
                countInfo.value = "❌ Images: " + thisDropzone.files.length + " / " + thisDropzone.options.maxFiles;
            }

            if (variablePricing == false) {
                if ( thisDropzone.options.maxFiles === 1) {
                    var toomuch = thisDropzone.files.length - 1;
                        if (thisDropzone.files.length < 1) {
                            countInfo.value = "Please add 1 image.";
                            document.querySelector(".btn-add-image").removeAttribute("disabled");
                            document.querySelector(".btn-add-image").classList.remove("hidden");
                            // totalPrice.setAttribute("hidden","hidden");
                            selectButton.setAttribute("disabled", "disabled");
                        }
                        if (thisDropzone.files.length > 1) {
                            countInfo.value = "Please remove " + toomuch + " images.";
                            document.querySelector(".btn-add-image").removeAttribute("disabled");
                            document.querySelector(".btn-add-image").classList.remove("hidden");
                            // totalPrice.setAttribute("hidden","hidden");
                            selectButton.setAttribute("disabled", "disabled");
                        }
                        if (thisDropzone.files.length == 1) {
                            countInfo.value = "✔ Images: " + thisDropzone.files.length + " / " + thisDropzone.options.maxFiles;
                            document.querySelector('.dz-message').style.display = "none";
                            document.querySelector(".btn-add-image").setAttribute("disabled","disabled");
                            document.querySelector(".btn-add-image").classList.add("hidden");
                            // totalPrice.removeAttribute("hidden");
                            selectButton.removeAttribute("disabled");
                            console.log("Number of images reached.");
                        }
                }
                if ( thisDropzone.options.maxFiles === 3) {
                    var toomuch = 3 - thisDropzone.files.length;
                        if (toomuch == 1) {
                            countInfo.value = "Please add " + toomuch + " image.";
                            document.querySelector(".btn-add-image").removeAttribute("disabled");
                            document.querySelector(".btn-add-image").classList.remove("hidden");
                            // totalPrice.setAttribute("hidden","hidden");
                            selectButton.setAttribute("disabled", "disabled");
                        }
                        if (countLeft > 1) {
                            countInfo.value = "Please add " + toomuch + " images.";
                            document.querySelector(".btn-add-image").removeAttribute("disabled");
                            document.querySelector(".btn-add-image").classList.remove("hidden");
                            // totalPrice.setAttribute("hidden","hidden");
                            selectButton.setAttribute("disabled", "disabled");
                        }
                        if (countLeft == 0) {
                            countInfo.value = "✔ Images: " + thisDropzone.files.length + " / " + thisDropzone.options.maxFiles;
                            document.querySelector('.dz-message').style.display = "none";
                            document.querySelector(".btn-add-image").setAttribute("disabled","disabled");
                            document.querySelector(".btn-add-image").classList.add("hidden");
                            // totalPrice.removeAttribute("hidden");
                            selectButton.removeAttribute("disabled");
                            console.log("Number of images reached.");
                        }
                }
                if ( thisDropzone.options.maxFiles === 6) {
                    var toomuch = 6 - thisDropzone.files.length;
                        if (toomuch == 1) {
                            countInfo.value = "Please add " + toomuch + " image.";
                            document.querySelector(".btn-add-image").removeAttribute("disabled");
                            document.querySelector(".btn-add-image").classList.remove("hidden");
                            // totalPrice.setAttribute("hidden","hidden");
                            selectButton.setAttribute("disabled", "disabled");
                        }
                        if (countLeft > 1) {
                            countInfo.value = "Please add " + toomuch + " images.";
                            document.querySelector(".btn-add-image").removeAttribute("disabled");
                            document.querySelector(".btn-add-image").classList.remove("hidden");
                            // totalPrice.setAttribute("hidden","hidden");
                            selectButton.setAttribute("disabled", "disabled");
                        }
                        if (countLeft == 0) {
                            countInfo.value = "✔ Images: " + thisDropzone.files.length + " / " + thisDropzone.options.maxFiles;
                            document.querySelector('.dz-message').style.display = "none";
                            document.querySelector(".btn-add-image").setAttribute("disabled","disabled");
                            document.querySelector(".btn-add-image").classList.add("hidden");
                            // totalPrice.removeAttribute("hidden");
                            selectButton.removeAttribute("disabled");
                            console.log("Number of images reached.");
                        }
                }
            }

            // if we don't have any files, disable
            // clearing and show drop message
            if (thisDropzone.files.length < 1) {
                console.log("No more files.");
                countInfo.value = "";
                countInfo.hidden = true;
                document.querySelector('.dz-message').style.display = "";
                document.querySelector(".dz-message").removeAttribute("hidden");
            }

            updateUploadFooterState();
        });

        // Store uploaded file IDs
        var uploadedFiles = [];

        this.on("sending", function (file, xhr, formData) {
            file._tipAnalyticsRequest = createUploadAttemptId();
            appendSubmissionAnalytics(formData, file._tipAnalyticsRequest);
            trackSubmissionEvent('upload_started', { request_id: file._tipAnalyticsRequest, file_size: file.size || 0 });
            if (!file._tipUploadId) {
                file._tipUploadId = createUploadAttemptId();
            }
            file._tipStartedAt = Date.now();
            file._tipLastProgress = 0;
            file._tipFailureHint = "";

            formData.append("upload_attempt_id", file._tipUploadId);
            formData.append("submission_attempt_id", submissionAttemptId);
            formData.append("client_file_name", file.name);
            formData.append("client_file_size", String(file.size || 0));
            formData.append("client_file_type", file.type || "");
            var alertEmail = submissionForm.querySelector('input[name="email"]');
            if (alertEmail && alertEmail.value) formData.append("tip_alert_email", alertEmail.value);

            xhr.addEventListener("timeout", function () {
                file._tipFailureHint = "timeout";
                // Dropzone 5.5 does not handle XHR timeouts itself.
                if (file.status === Dropzone.UPLOADING) {
                    file.status = Dropzone.ERROR;
                    thisDropzone.emit("error", file, "Upload timedout", xhr);
                    thisDropzone.emit("complete", file);
                }
            });
            xhr.addEventListener("abort", function () {
                file._tipFailureHint = "abort";
            });
            xhr.addEventListener("error", function () {
                if (!file._tipFailureHint) {
                    file._tipFailureHint = "network_error";
                }
            });

            selectButton.classList.add("is-loading");
            selectButton.disabled = true;
        });

        this.on("uploadprogress", function (file, progress) {
            file._tipLastProgress = progress;
            if (!submitStarted || totalFiles === 0) return;

            // progress = 0–100 for *current file*
            const fileIndex = completedFiles; // files already done
            const overallProgress =
                ((fileIndex + progress / 100) / totalFiles) * 100;

            progressBarTotal.style.width = Math.min(overallProgress, 100) + "%";
        });


        // Handle successful file upload to REST endpoint
        this.on("success", function (file, response) {
            completedFiles++;

            const percent = Math.round((completedFiles / totalFiles) * 100);
            progressBarTotal.style.width = percent + "%";

            if (completedFiles < totalFiles) {
                progressBarText.textContent = `Uploading ${completedFiles + 1} of ${totalFiles}`;
            } else {
                progressBarText.textContent = "Processing submission";
            }

            if (response && response.success && Array.isArray(response.files) && response.files.length === 1 && response.files[0] && response.files[0].filename) {
                file._tipUploadedFiles = response.files;
                response.files.forEach(function (fileData) {
                    uploadedFiles.push(fileData);
                });

                // ✅ Safe, non-sensitive log
                if (debug) {
                    console.log("[DROPZONE] Uploaded files count:", uploadedFiles.length);
                }

            } else {
                file.status = Dropzone.ERROR;
                thisDropzone.emit("error", file, "Upload failed. Please try again.", file.xhr);
            }
        });


        // Handle completion of all uploads
        this.on("queuecomplete", function () {
            if (!submitStarted) return;
            submitStarted = false; // ✅ DISARM

            if (uploadAborted) {
                uploadAborted = false;
                return;
            }

            if (
                uploadedFiles.length > 0 &&
                thisDropzone.getAcceptedFiles().length === uploadedFiles.length
            ) {
                submitFormWithFiles();
            } else {
                displayMessage({
                    status: "error",
                    message: "One or more images failed to upload. Please retry."
                });
                selectButton.classList.remove("is-loading");
                selectButton.disabled = false;
            }
        });


        // Submit form with uploaded file IDs
        function submitFormWithFiles() {
            if (submissionPending) return;
            trackSubmissionEvent('uploads_complete');
            console.log('[DROPZONE] submitFormWithFiles called, uploadedFiles.length:', uploadedFiles.length);
            
            if (uploadedFiles.length === 0) {
                console.error('[DROPZONE] ERROR: No files to submit');
                reportSubmissionError('submission', 'no_uploaded_files');
                displayMessage({
                    status: "error",
                    message: "No files were uploaded. Please try again."
                });
                selectButton.classList.remove("is-loading");
                selectButton.disabled = false;
                return;
            }

            // Get form data
            var formData = new FormData(submissionForm);
            appendSubmissionAnalytics(formData);
            formData.append('action', 'submission');
            
            var uploadedFilesJson = JSON.stringify(uploadedFiles);
            formData.append('uploaded_files', uploadedFilesJson);
            
            console.log('[DROPZONE] Submitting form with uploaded_files:', uploadedFilesJson.substring(0, 200) + '...');

            // Submit to admin-post.php
            var xhr = new XMLHttpRequest();
            xhr.open('POST', ajax_urls.admin_ajax, true);
            submissionPending = true;
            
            xhr.onload = function() {
                submissionPending = false;
                selectButton.classList.remove("is-loading");
                selectButton.disabled = false;
                
                if (xhr.status === 200) {
                    try {
                        var response = JSON.parse(xhr.responseText);
                        if (response.success) {
                            displayMessage({
                                status: "success",
                                message: "Your files have been uploaded, you will be redirected shortly."
                            });
                            window.location.href = response.data.checkout_url || ("/submissions/" + response.data.redirect_url);
                        } else {
                            reportSubmissionError('submission', 'submission_rejected', {
                                status: xhr.status,
                                message: (response.data && response.data.message) || 'Submission was rejected.'
                            });
                            displayMessage({
                                status: "error",
                                message: (response.data && response.data.message) || "An error occurred. Please try again."
                            });

                            console.log('Submission error response:', response);
                        }
                    } catch (e) {
                        reportSubmissionError('submission', 'invalid_server_response', {
                            status: xhr.status,
                            message: e && e.message ? e.message : 'Invalid JSON response'
                        });
                        displayMessage({
                            status: "error",
                            message: "An error occurred processing your submission. Please try again."
                        });
                    }
                } else {
                    var serverMessage = "Server error. Please try again later.";
                    try {
                        var errorResponse = JSON.parse(xhr.responseText);
                        if (errorResponse && errorResponse.data && errorResponse.data.message) {
                            serverMessage = errorResponse.data.message;
                        }
                    } catch (e) {
                        // Keep the generic fallback for non-JSON proxy/server errors.
                    }
                    reportSubmissionError('submission', 'http_' + xhr.status, {
                        status: xhr.status,
                        message: serverMessage
                    });
                    displayMessage({
                        status: "error",
                        message: serverMessage
                    });
                }
            };
            
            xhr.onerror = function() {
                submissionPending = false;
                selectButton.classList.remove("is-loading");
                selectButton.disabled = false;
                reportSubmissionError('submission', 'network_error', {
                    status: xhr.status || 0,
                    message: 'The submission request did not receive a response.'
                });
                displayMessage({
                    status: "error",
                    message: "Network error. Please check your connection and try again."
                });
            };
            
            xhr.send(formData);
        }
    }
};

document.addEventListener("DOMContentLoaded", function() {
    console.log("Submissions loaded.");

    var emailField = document.getElementById("email");
    var emailSuggestion = document.getElementById("email-domain-suggestion");
    var commonEmailTypos = {
        "gmial.com": "gmail.com",
        "gamil.com": "gmail.com",
        "gmai.com": "gmail.com",
        "hotnail.com": "hotmail.com",
        "outlok.com": "outlook.com",
        "yahooo.com": "yahoo.com"
    };

    if (emailField && emailSuggestion) {
        var suggestionButton = emailSuggestion.querySelector("button");
        emailField.addEventListener("blur", function() {
            var parts = emailField.value.trim().split("@");
            var correctedDomain = parts.length === 2 ? commonEmailTypos[parts[1].toLowerCase()] : "";
            if (!correctedDomain) {
                emailSuggestion.hidden = true;
                return;
            }

            suggestionButton.textContent = parts[0] + "@" + correctedDomain;
            emailSuggestion.hidden = false;
        });
        suggestionButton.addEventListener("click", function() {
            emailField.value = suggestionButton.textContent;
            emailSuggestion.hidden = true;
            emailField.focus();
        });
    }

    var loginForm = document.querySelector("#submit-login-card form");
    if (loginForm) {
        loginForm.addEventListener("submit", function() {
            window.sessionStorage.setItem("submitScrollToContactInfo", "1");
        }, true);
    }

    document.querySelectorAll(".enter-button").forEach(function(button) {
        button.addEventListener("click", function(event) {
            var target = document.querySelector(button.getAttribute("href"));
            if (!target) return;
            event.preventDefault();
            target.scrollIntoView({ behavior: "smooth", block: "start" });
        });
    });

    if (
        document.body.classList.contains("logged-in") &&
        window.sessionStorage.getItem("submitScrollToContactInfo") === "1"
    ) {
        window.sessionStorage.removeItem("submitScrollToContactInfo");
        window.setTimeout(function() {
            scrollToContactInfo();
        }, 250);
    }
    
    // ------------------------------------------
    // Submission form info toggling (for titles)
    // ------------------------------------------

    submissionForm.addEventListener("change", function(e) {
        var countInfo = document.getElementById("counter-info");
        var radioSelected = document.querySelector('input[name="price"]:checked');
        thisDropzone.options.maxFiles = radioSelected.value;
        updateTotalCost();
        document.getElementById("total-cost").textContent = getCurrencySymbol() + totalCost;
        var totalPrice = document.getElementById("totalprice");
        var addButtons = document.getElementById("add-buttons");
        var allAdded = document.querySelectorAll(".dz-clickable")[1];

        if (+e.target.value === 1) {
            thisDropzone.options.maxFiles = 1;
            variablePricing = false;
        }

        if (+e.target.value === 3) {
            thisDropzone.options.maxFiles = 3;
            variablePricing = false;
        }

        if (+e.target.value === 6) {
            thisDropzone.options.maxFiles = 6;
            variablePricing = false;
        }

        var countLeft = thisDropzone.options.maxFiles - thisDropzone.files.length;
        var toomuch = thisDropzone.files.length - thisDropzone.options.maxFiles;

        if (variablePricing === false) {
        if (thisDropzone.files.length < thisDropzone.options.maxFiles) {
            document.querySelector(".btn-add-image").classList.remove("hidden");
            document.querySelector(".btn-add-image").removeAttribute("disabled");
            if (countLeft == 1) {
                countInfo.value = "Please add " + countLeft + " image.";
            }
            if (countLeft > 1) {
                countInfo.value = "Please add " + countLeft + " images.";
            }
            // totalPrice.setAttribute("hidden","hidden");
            selectButton.setAttribute("disabled", "disabled");
        }
        if (thisDropzone.files.length > thisDropzone.options.maxFiles) {
            document.querySelector(".btn-add-image").classList.add("hidden");
            document.querySelector(".btn-add-image").setAttribute("disabled","disabled");
            if (toomuch == 1) {
            countInfo.value = "Please remove " + toomuch + " image.";
            }
            if (toomuch > 1) {
            countInfo.value = "Please remove " + toomuch + " images.";
            }
            // totalPrice.setAttribute("hidden","hidden");
            selectButton.setAttribute("disabled", "disabled");
        }
        if (thisDropzone.files.length == thisDropzone.options.maxFiles) {
            selectButton.removeAttribute("disabled");
            console.log("Number of images reached.");
            addButtons.removeAttribute("hidden");
            allAdded.setAttribute("disabled", "");
            document.querySelector(".btn-add-image").classList.add("hidden");
            document.querySelector('.dz-message').style.display = "none";
            countInfo.value = "✔ Images: " + thisDropzone.files.length + " / " + thisDropzone.options.maxFiles;
        }
    }

     if (variablePricing === true) {
        if (thisDropzone.files.length < 6) {
            countLeft = 6 - thisDropzone.files.length;
            document.querySelector(".btn-add-image").classList.remove("hidden");
            document.querySelector(".btn-add-image").removeAttribute("disabled");
            if (countLeft == 1) {
                countInfo.value = "Please add " + countLeft + " image minimum.";
            }
            if (countLeft > 1) {
                countInfo.value = "Please add " + countLeft + " images minimum.";
            }
            // totalPrice.setAttribute("hidden","hidden");
            selectButton.setAttribute("disabled", "disabled");
        }
        if (thisDropzone.files.length >= 6) {
            selectButton.removeAttribute("disabled");
            console.log("Number of images reached.");
            addButtons.removeAttribute("hidden");
            allAdded.setAttribute("disabled", "");
            document.querySelector(".btn-add-image").classList.remove("hidden");
            document.querySelector(".btn-add-image").removeAttribute("disabled");
            document.querySelector('.dz-message').style.display = "none";
            countInfo.value = "✔ Images: " + thisDropzone.files.length + " / 12";
        }
        if (thisDropzone.files.length >= 13) {
            document.querySelector(".btn-add-image").classList.remove("hidden");
            document.querySelector(".btn-add-image").removeAttribute("disabled");
            countLeft = thisDropzone.files.length - 12;
            if (countLeft == 1) {
                countInfo.value = "Please remove " + countLeft + " image.";
            }
            if (countLeft > 1) {
                countInfo.value = "Please remove " + countLeft + " images.";
            }
            // totalPrice.setAttribute("hidden","hidden");
            selectButton.setAttribute("disabled", "disabled");
        }
     }

        if (typeof window.tipUpdateUploadFooterState === "function") {
            window.tipUpdateUploadFooterState();
        }
    });
});


// ----------------------------------
// remove hidden class from targetted
// element, add it to clicked element
// ----------------------------------

var showButton = document.querySelector(".js-show");

showButton && showButton.addEventListener("click", function(e){
    e.preventDefault();

    var target = document.getElementById(this.getAttribute("data-target"));

    this.classList.add("hidden");
    target.classList.remove("hidden");
    target.focus();
});


// ----------------------------------
// remove hidden class from targetted
// element, add it to clicked element
// ----------------------------------

var voucherButton = document.querySelector(".js-voucher");
var voucherMessage = document.querySelector(".js-voucher-message");



voucherButton && voucherButton.addEventListener("click", function(e){
    e.preventDefault();

    var voucher = submissionForm.voucher.value;
    var email = submissionForm.email.value;
    var givenName = submissionForm.fname.value;
    var surname = submissionForm.lname.value;
    var voucherClass = document.querySelector(".voucherclass");

    var previousPrices = document.querySelectorAll(".previous-price");
    var currentPrices = document.querySelectorAll(".price");
    var applyButton = document.getElementById("applybutton");

    voucherButton.classList.add("is-loading");

    var queryURI = encodeData({
        action: "voucher",
        voucher: voucher,
        email: email,
    });

    var xhr = new XMLHttpRequest();

    xhr.open("POST", ajax_urls.admin_ajax);
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

    xhr.addEventListener("load", function(){
        if (debug) console.log(xhr);

        console.warn(xhr.responseText)
        var response = JSON.parse(xhr.responseText);

        voucherButton.setAttribute("disabled", true);
        voucherButton.classList.remove("is-loading");

        voucherMessage.innerHTML = response.message;
        voucherMessage.classList.add("is-active");

        setTimeout(function() {
            voucherMessage.classList.remove("is-active");
        }, 5000);

        if (response.status === "success") {
            
            currentPrices.forEach(function(el, index){
    
                var previousPrice = parseInt(el.innerHTML);
    
                previousPrices[index].classList.add("is-visible");
                voucherClass.setAttribute("readonly", true);
                applyButton.innerHTML = "Applied!";
                voucherButton.setAttribute("disabled", true);
    
                animateValue(el, previousPrice, response.prices[index], 500);
            });

        } else {

            voucherButton.disabled = false;
            voucherClass.value = "";

        }

    });

    xhr.send(queryURI);
});


// Function to update total cost display
function updateTotalCost() {
    var countInfo = document.getElementById("counter-info");
    var totalCostElement = document.getElementById("total-cost");
    var selectedPrice = document.querySelector('input[name="price"]:checked');

    // Calculate total cost based on the number of images in Dropzone
    var numImages = selectedPrice ? parseInt(selectedPrice.value, 10) : thisDropzone.files.length;
    totalCost = prices[numImages] || prices[12]; // Default to max price if not found

    // Update the total cost display in the DOM
    if (totalCostElement) {
        totalCostElement.textContent = selectedPrice ? getCurrencySymbol() + totalCost : "—";
    }
}


function displayMessage(messageObj) {

    var messageElem = document.getElementById("message-box");
    var submitElem = document.getElementById("select");
    var iconMarkup = messageObj.status === "success"
        ? '<svg viewBox="0 0 24 24" focusable="false"><path d="M20 6 9 17l-5-5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg>'
        : '<svg viewBox="0 0 24 24" focusable="false"><path d="M12 9v4m0 4h.01M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/></svg>';

    submitElem.classList.remove("is-loading");
    submitElem.disabled = false;

    messageElem.classList.remove("success");
    messageElem.classList.remove("error");
    messageElem.classList.remove("isClosing");

    messageElem.classList.add(messageObj.status);
    messageElem.innerHTML = [
        '<div class="site-notice site-notice--' + messageObj.status + '" role="' + (messageObj.status === "error" ? "alert" : "status") + '">',
            '<span class="site-notice__icon" aria-hidden="true">' + iconMarkup + '</span>',
            '<p class="site-notice__message"></p>',
            '<button type="button" class="site-notice__close" aria-label="Close notification">',
                '<svg viewBox="0 0 24 24" focusable="false"><path d="M6 6 18 18M18 6 6 18" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.8"/></svg>',
            '</button>',
        '</div>'
    ].join("");

    messageElem.querySelector(".site-notice__message").textContent = messageObj.message;

    messageElem.classList.add("isActive");

    window.clearTimeout(messageHideTimeout);

    var dismiss = function() {
        messageElem.classList.add("isClosing");
        window.setTimeout(function() {
            messageElem.classList.remove("isActive");
            messageElem.classList.remove("isClosing");
        }, 220);
    };

    var closeButton = messageElem.querySelector(".site-notice__close");
    if (closeButton) {
        closeButton.addEventListener("click", dismiss, { once: true });
    }

    messageHideTimeout = window.setTimeout(function() {
        dismiss();
    }, 8000);

    messageElem.addEventListener("click", function(event) {
        if (event.target === messageElem) {
            dismiss();
        }
    }, { once: true });

    setTimeout(function() {
        messageElem.classList.remove("isActive");
        messageElem.classList.remove("isClosing");
    }, 8250);
}

// encodes the given object into a usable URI
// with keys and values to be passed via XMLHttpRequest
var encodeData = function(object) {

    return Object.keys(object).map(
        function(k){
            return encodeURIComponent(k) + "=" + encodeURIComponent(object[k])
        }
    ).join("&");
};

function animateValue(el, start, end, duration) {

    // animating equal values kinda breaks this
    if (start == end) return false;

    var range = end - start;
    var current = start;
    var increment = end > start? .5 : -.5;
    var stepTime = Math.abs(Math.floor(duration / range));
    var obj = el;
    var timer = setInterval(function() {
        current += increment;
        obj.innerHTML = current;
        if (current == end) {
            clearInterval(timer);
        }
    }, 10);
}

function handlePricingSelection(imageFee, priceCount) {
    var pricingRows = document.getElementsByClassName('pricingrow');
    var selectedRow = pricingRows[priceCount];
    var selectedCount = selectedRow ? parseInt(selectedRow.value, 10) : 0;
    var pricingOption = document.getElementById('pricingoption');
    var totalCostElement = document.getElementById("total-cost");

    if (pricingOption && selectedRow) {
        pricingOption.value = selectedRow.value;
    }

    if (selectedCount && thisDropzone) {
        thisDropzone.options.maxFiles = selectedCount;
    }

    if (totalCostElement) {
        totalCostElement.textContent = getCurrencySymbol() + imageFee;
    }

    if (window.tipUpdateUploadFooterState) {
        window.tipUpdateUploadFooterState();
    }
}
